export const COPY_JOB_ID_KEY: string = 'copyJobId';
export const JOB_ID_KEY: string = 'jobId';
